import Const from '../Const';
export {
  COMMON_CHART,
  ChartConfig,
  SETTING_DARK,
  SETTING_LIGHT,
  SETTING_CLASSIC,
  setFillColor,
};

const COMMON_CHART = {
  HEIGHT: 300,
  RATE_SHARP_FONT: 0.7,
  MIN_VISIBLE_FONT_SIZE: 10,
  RATE_ZOOM: 3,
  MARGIN: { left: 50, right: 20, top: 20, bottom: 20 },
  COLOR_GREEN_TEXT: '#009d5b',
  COLOR_GREEN_CHART: '#009d5b',
  COLOR_GREEN_CHART_HOVER: '#00de8b',
  COLOR_RED_TEXT: '#e94235',
  COLOR_RED_CHART: '#e63946',
  COLOR_RED_CHART_HOVER: '#ff5d68',
  COLOR_DARK_BLUE: '#1e242e',
  COLOR_GRAY: '#555555',
  COLOR_BLACK: '#000000',
  COLOR_WHITE: '#ffffff',
  COLOR_GRID: '#555555',
  COLOR_TEXT_DARK: '#ffffff',
  COLOR_TEXT_LIGHT: '#1f2023',
  COLOR_GREEN: '#009d5b',
  COLOR_RED: '#f11a09',
  FONT_FAMILY: 'Arial',
  MAX_RADIUS: 20,
  MIN_RADIUS: 3,
  SM_SIZE: 10,
  MD_SIZE: 12,
  LG_SIZE: 14,
  BIG_SIZE: 20,

  Y_EXTENTS_PADDING: 1, // padding max/min value of y extend
};

const ChartConfig = {
  Dark: {
    ...COMMON_CHART,
    COLOR_TEXT: COMMON_CHART.COLOR_TEXT_DARK,
    TEXT_COLOR: '#ffffff',
  },
  Light: {
    ...COMMON_CHART,
    COLOR_TEXT: COMMON_CHART.COLOR_TEXT_LIGHT,
    TEXT_COLOR: '#1f2023',
    COLOR_RED_CHART_HOVER: '#ff1200',
  },
  Classic: {
    ...COMMON_CHART,
    COLOR_TEXT: COMMON_CHART.COLOR_TEXT_DARK,
    TEXT_COLOR: '#ffffff',
  },
};

const SETTING_DARK = {
  ...COMMON_CHART,
  COLOR_TEXT: COMMON_CHART.COLOR_TEXT_DARK,
  TEXT_COLOR: '#ffffff',
};

const SETTING_LIGHT = {
  ...COMMON_CHART,
  COLOR_TEXT: COMMON_CHART.COLOR_TEXT_LIGHT,
  TEXT_COLOR: '#1f2023',
  COLOR_RED_CHART_HOVER: '#ff1200',
};

const SETTING_CLASSIC = {
  ...COMMON_CHART,
  COLOR_TEXT: COMMON_CHART.COLOR_TEXT_DARK,
  TEXT_COLOR: '#ffffff',
};

const setFillColor = (d, SETTINGS) => {
  const arrColor =
    d[Const.listContribution.CONTRIBUTION] > 0
      ? [SETTINGS.COLOR_GREEN_CHART, SETTINGS.COLOR_GREEN_CHART_HOVER]
      : [SETTINGS.COLOR_RED_CHART, SETTINGS.COLOR_RED_CHART_HOVER];
  return arrColor;
};
